import type { Identifier } from "dnd-core";
import { useRef } from "react";
import { useDrop } from "react-dnd";
import { DragItem } from "./types";

type Props = {
  accept: string[];
  dropHandler: (item: DragItem<unknown>) => void;
  index: number;
};

export default function useDropzone({ accept, index, dropHandler }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [{ handlerId, isOver }, drop] = useDrop<
    DragItem<unknown>,
    void,
    {
      handlerId: Identifier | null;
      item: DragItem<unknown> | null;
      isOver: boolean;
    }
  >({
    accept,
    collect: (monitor) => ({
      item: monitor.getItem(),
      handlerId: monitor.getHandlerId(),
      isOver: monitor.isOver(),
    }),
    drop: (item: DragItem<unknown>) => dropHandler(item),
    hover(item: DragItem<unknown>) {
      if (!ref.current) {
        return;
      }

      item.hoverIndex = index;
    },
  });

  drop(ref);

  return { isOver, handlerId, ref };
}
